var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contanier"},[_c('div',{staticClass:"row"},[_c('products-Table',{staticClass:"flex md12 sm12 xs12"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }